import { useCustomSuspenseQuery } from "@/hooks/use-graphql-client";

import { HOTEL_NOTIFICATION_SETTING_QUERY } from "./schema";

export const useHotelNotificationSettingsQuery = (hotelID: string) => {
	const { data } = useCustomSuspenseQuery(HOTEL_NOTIFICATION_SETTING_QUERY, { variables: { hotelID } });

	return {
		data,
	};
};
